import React from "react";
import gpkp_top from "../../assets/images/QYQW/qyqw_title.png";
import tab1 from "../../assets/images/QYQW/qyqw_btn.png";
import tab2 from "../../assets/images/QYQW/qyqw_btn2.png";
import tab3 from "../../assets/images/QYQW/qyqw_btn3.png";
import "./index.scss";
import { Link } from "react-router-dom";
export default function GQKP() {
  const tabList = [
    { img: tab1, to: "/GQKP/QYQW" },
    { img: tab2, to: "/GQKP/QZCG" },
    { img: tab3, to: "/GQKP/QHXZ" },
  ];
  return (
    <div className="gqkp-page">
      <img src={gpkp_top} className="top-img" alt="" />
      <div className="tab-list">
        {tabList.map((item) => {
          return (
            <Link to={item.to} key={item.to}>
              <img src={item.img} alt="" />
            </Link>
          );
        })}
      </div>
      {/* <div className="bottom-text">重庆中国三峡博物馆</div> */}
    </div>
  );
}
